import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { IoMenu } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import TwoWheelerIcon from "@mui/icons-material/TwoWheeler";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useMyContext } from "../store/ContextApi";
import logo from "../logo192.png";

const Navbar = () => {
  //handle the header opening and closing menu for the tablet/mobile device
  const [headerToggle, setHeaderToggle] = useState(false);
  const pathName = useLocation().pathname;
  const navigate = useNavigate();

  // Access the states by using the useMyContext hook from the ContextProvider
  const { token, setToken, setCurrentUser, isAdmin, setIsAdmin, isWorker } =
    useMyContext();

  const handleLogout = () => {
    localStorage.removeItem("JWT_TOKEN"); // Updated to remove token from localStorage
    localStorage.removeItem("USER"); // Remove user details as well
    localStorage.removeItem("CSRF_TOKEN");
    localStorage.removeItem("IS_ADMIN");
    setToken(null);
    setCurrentUser(null);
    setIsAdmin(false);
    navigate("/login");
  };

  useEffect(() => {
    if (localStorage.getItem("JWT_TOKEN") === null) {
      navigate("/");
    }
  }, [token]);

  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-VN18C7ERM9";
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    window.gtag("js", new Date());
    window.gtag("config", "G-VN18C7ERM9");
  }, []);

  const partnerAds = [
    {
      name: "Tricles",
      tagline: "Buy & Sell Cars",
      url: "https://www.tricles.com",
      icon: DirectionsCarIcon,
      hoverGlow: "hover:shadow-indigo-500/50",
      bgClass: "bg-gradient-to-r from-blue-600 via-indigo-600 to-violet-600",
    },
    {
      name: "Bluebike",
      tagline: "Buy & Sell Bikes",
      url: "https://www.bluebike.in",
      icon: TwoWheelerIcon,
      hoverGlow: "hover:shadow-amber-500/40",
      bgClass: "bg-gradient-to-r from-amber-500 via-orange-500 to-rose-500",
    },
  ];

  return (
    <header className="z-50 text-textColor bg-sky-400 shadow-sm sticky top-0">
      <nav className="sm:px-10 px-4 flex w-full h-headerHeight items-center justify-between">
        <Link to="/">
          {" "}
          <div className="flex flex-row h-14">
            <img src={logo} alt="logo" />
            {/* <h3 className=" font-dancingScript text-logoText">Blue Washer</h3> */}
          </div>
        </Link>
        <ul
          className={`lg:static  absolute left-0  top-16 w-full lg:w-fit lg:px-0 sm:px-10 px-4  lg:bg-transparent bg-headerColor   ${
            headerToggle
              ? "min-h-fit max-h-navbarHeight lg:py-0 py-4 shadow-md shadow-slate-700 lg:shadow-none"
              : "h-0 overflow-hidden "
          }  lg:h-auto transition-all duration-100 font-montserrat text-textColor flex lg:flex-row flex-col lg:gap-8 gap-2`}
        >
          {token && (
            <>
              <Link to="/create-booking">
                <li
                  className={` py-2 cursor-pointer  hover:text-slate-300 ${
                    pathName === "/create-booking" ? "font-semibold " : ""
                  } `}
                >
                  Create Booking
                </li>
              </Link>
            </>
          )}

          <Link to="/about">
            <li
              className={`py-2 cursor-pointer hover:text-slate-300 ${
                pathName === "/about" ? "font-semibold " : ""
              }`}
            >
              About
            </li>
          </Link>

          <Link to="/privacy">
            <li
              className={`py-2 cursor-pointer hover:text-slate-300 ${
                pathName === "/privacy" ? "font-semibold " : ""
              }`}
            >
              Privacy Policy
            </li>
          </Link>
          <Link to="/disclaimer">
            <li
              className={`py-2 cursor-pointer hover:text-slate-300 ${
                pathName === "/disclaimer" ? "font-semibold " : ""
              }`}
            >
              Disclaimer
            </li>
          </Link>
          <Link to="/terms">
            <li
              className={`py-2 cursor-pointer hover:text-slate-300 ${
                pathName === "/terms" ? "font-semibold " : ""
              }`}
            >
              Terms & Conditions
            </li>
          </Link>

          {token ? (
            <>
              <Link to="/profile">
                <li
                  className={` py-2 cursor-pointer  hover:text-slate-300 ${
                    pathName === "/profile" ? "font-semibold " : ""
                  }`}
                >
                  Profile
                </li>
              </Link>{" "}
              {isAdmin && (
                <Link to="/admin/all-bookings">
                  <li
                    className={` py-2 cursor-pointer uppercase   hover:text-slate-300 ${
                      pathName.startsWith("/admin") ? "font-semibold " : ""
                    }`}
                  >
                    Admin
                  </li>
                </Link>
              )}
              {isWorker && (
                <Link to="/earning-summary-report">
                  <li
                    className={` py-2 cursor-pointer uppercase   hover:text-slate-300 ${
                      pathName.startsWith("/earning-summary-report")
                        ? "font-semibold "
                        : ""
                    }`}
                  >
                    My Earnings
                  </li>
                </Link>
              )}
              <button
                onClick={handleLogout}
                className="w-24 text-center bg-customRed font-semibold px-4 py-2 rounded-sm cursor-pointer hover:text-slate-300"
              >
                LogOut
              </button>
            </>
          ) : (
            <Link to="/login">
              <li className="w-24 text-center bg-btnColor font-semibold px-4 py-2 rounded-sm cursor-pointer hover:text-slate-300">
                Sign In
              </li>
            </Link>
          )}
        </ul>
        <span
          onClick={() => setHeaderToggle(!headerToggle)}
          className="lg:hidden block cursor-pointer text-textColor  shadow-md hover:text-slate-400"
        >
          {headerToggle ? (
            <RxCross2 className=" text-2xl" />
          ) : (
            <IoMenu className=" text-2xl" />
          )}
        </span>
      </nav>
      {/* Partner ads - only on landing page, below menu bar */}
      {pathName === "/" && (
        <div className="w-full px-2 sm:px-6 py-2 sm:py-2.5 bg-gradient-to-r from-slate-800 to-slate-900 border-b border-slate-700/50">
          <div className="flex flex-nowrap items-center justify-center gap-2 sm:gap-4">
            {partnerAds.map((partner) => {
              const Icon = partner.icon;
              return (
                <a
                  key={partner.name}
                  href={partner.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`group flex flex-1 min-w-0 items-center gap-1.5 sm:gap-3 px-2 py-2 sm:px-4 sm:py-2.5 rounded-lg sm:rounded-xl ${partner.bgClass} text-white font-semibold shadow-lg ${partner.hoverGlow} hover:shadow-xl hover:scale-[1.03] active:scale-[0.98] transition-all duration-300 border border-white/20 hover:border-white/40`}
                >
                  <span className="flex shrink-0 items-center justify-center w-7 h-7 sm:w-9 sm:h-9 rounded-md sm:rounded-lg bg-white/20 backdrop-blur-sm group-hover:bg-white/30 transition-colors">
                    <Icon sx={{ fontSize: { xs: 18, sm: 22 } }} />
                  </span>
                  <div className="text-left min-w-0 flex-1">
                    <span className="block text-xs sm:text-base leading-tight truncate">{partner.name}</span>
                    <span className="block text-[10px] sm:text-sm font-medium text-white/90 truncate">{partner.tagline}</span>
                  </div>
                  <ArrowForwardIcon className="shrink-0 opacity-80 group-hover:translate-x-0.5 group-hover:opacity-100 transition-all" sx={{ fontSize: { xs: 16, sm: 18 } }} />
                </a>
              );
            })}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;


